import React from 'react';
import "./BadgeNew.css";

interface BadgeNewProps{
    show : boolean;
    text?: string;
    /** Optional background color override. Falls back to the default (red). */
    color?: string;
}

const BadgeNew:React.FC<BadgeNewProps> = ({show, text = "Neu", color}) => {
  if(show){
    // `color` may be a solid color or a CSS gradient string (e.g.
    // "linear-gradient(...)"). A gradient must be set via background-image.
    const style = color
      ? (color.includes("gradient") ? { backgroundImage: color } : { backgroundColor: color })
      : undefined;
    return (
        <div className="badge-new" style={style}>{text}</div>
      )

  } else {
    return <></>
  }
}

export default BadgeNew